import { Link, TableBody, TableCell, TableRow } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import React, { memo } from 'react';
import TableSkeleton from '../../components/TableSkeleton';
import { useTransferStories } from '../../hooks/queries/useTransfer';
import { getMGContractType, numberToCurrency } from '../../services/utils';
import useStyles from './TransferStoriesStyles';

interface IProps {
  transferId: number;
}

const TransferQuarterlyStories = (props: IProps): JSX.Element => {
  const SKELETON_COLUMNS = 16;
  const classes = useStyles();

  const { data, isLoading } = useTransferStories(props.transferId);

  return (
    <>
      <TableBody component={'tbody'} className={classes.tableBody}>
        <TableRow component={'tr'}>
          <TableCell component={'td'} className={classes.tableTitle} colSpan={2}></TableCell>
          <TableCell component={'td'} className={classes.tableTitle} align="left" colSpan={1234}>
            * Payments Details
          </TableCell>
        </TableRow>
        <TableRow component={'tr'} className={`${classes.tableRow} ${classes.thead}`}>
          <TableCell component={'td'} style={{ width: 30 }}></TableCell>
          <TableCell component={'td'} style={{ width: 30 }}></TableCell>
          <TableCell component={'td'} align="center" rowSpan={2}>
            Title
          </TableCell>
          <TableCell component={'td'} align="center" rowSpan={2} style={{ width: 157 }}>
            Story ID/Season ID
          </TableCell>
          <TableCell component={'td'} align="center" rowSpan={2}>
            Writer&apos;s name
          </TableCell>
          <TableCell component={'td'} align="center" rowSpan={2}>
            Total Coins Redeemed(Coins)
          </TableCell>
          <TableCell component={'td'} align="center" rowSpan={2}>
            Carried On(Coins)
          </TableCell>
          <TableCell component={'td'} align="center" colSpan={4}>
            Earnings($)
          </TableCell>
          <TableCell component={'td'} align="center" rowSpan={2}>
            Amount
          </TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}> </TableCell>
        </TableRow>
        <TableRow component={'tr'} className={`${classes.tableRow} ${classes.thead}`}>
          <TableCell component={'td'} colSpan={2}></TableCell>
          <TableCell component={'td'} align="center">
            Paid Coins(Exclude Ads)
          </TableCell>
          <TableCell component={'td'} align="center">
            Radish PLUS Pool
          </TableCell>
          <TableCell component={'td'} align="center">
            Ad Coins
          </TableCell>
          <TableCell component={'td'} align="center">
            Free Coins
          </TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}></TableCell>
          <TableCell component={'td'}> </TableCell>
        </TableRow>
        {isLoading && <TableSkeleton rows={1} columns={SKELETON_COLUMNS} isOriginalDefaultComponent={true} />}
        {!isLoading &&
          data &&
          data.transferStories?.map(item => (
            <React.Fragment key={`transfer-detail-row-story-${item.story.id}`}>
              <TableRow component={'tr'} className={classes.tableRow}>
                <TableCell component={'td'}></TableCell>
                <TableCell component={'td'}></TableCell>
                <TableCell component={'td'} align="left">
                  <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${item.story.id}`} target="_blank">
                    {item.story.title}
                  </Link>
                </TableCell>
                <TableCell component={'td'} align="center">
                  <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${item.story.id}`} target="_blank">
                    {item.story.id}
                  </Link>
                </TableCell>
                <TableCell component={'td'} align="center">
                  <RouterLink className={classes.routerLink} to={`/penname/v/${item.story.penname.id}`}>
                    {item.story.penname.name}
                  </RouterLink>
                </TableCell>
                <TableCell component={'td'} align="right">
                  {Number(item.coins - item.carriedOnCoins).toLocaleString()}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {Number(item.carriedOnCoins).toLocaleString()}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {numberToCurrency(item.paidEarnings - item.adsEarnings)}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {numberToCurrency(item.radishPlusEarnings)}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {numberToCurrency(item.adsEarnings)}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {numberToCurrency(item.freeEarnings)}
                </TableCell>
                <TableCell component={'td'} align="right">
                  {numberToCurrency(item.amount)}
                </TableCell>
                <TableCell component={'td'}></TableCell>
                <TableCell component={'td'}></TableCell>
                <TableCell component={'td'}></TableCell>
                <TableCell component={'td'}></TableCell>
              </TableRow>
              {item.transfersBySeason.map(seasonItem => (
                <TableRow component={'tr'} key={`transfer-detail-row-season-${seasonItem.season.id}`} className={classes.tableRow}>
                  <TableCell component={'td'}></TableCell>
                  <TableCell component={'td'}></TableCell>
                  <TableCell component={'td'} align="left">
                    <span className={classes.icon} />
                    <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${item.story.id}/seasons/${seasonItem.season.id}`} target="_blank">
                      {item.story.isCustomSeasonTitle ? seasonItem.season.title : `Season ${seasonItem.season.no}`}
                    </Link>
                  </TableCell>
                  <TableCell component={'td'} align="center">
                    <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${item.story.id}/seasons/${seasonItem.season.id}`} target="_blank">
                      {seasonItem.season.id}
                    </Link>
                  </TableCell>
                  <TableCell component={'td'} align="center">
                    <RouterLink className={classes.routerLink} to={`/penname/v/${item.story.penname.id}`}>
                      {item.story.penname.name}
                    </RouterLink>
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {Number(seasonItem.coins - seasonItem.carriedOnCoins).toLocaleString()}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {Number(seasonItem.carriedOnCoins).toLocaleString()}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {numberToCurrency(seasonItem.paidEarnings - seasonItem.adsEarnings)}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {numberToCurrency(seasonItem.radishPlusEarnings)}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {numberToCurrency(seasonItem.adsEarnings)}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {numberToCurrency(seasonItem.freeEarnings)}
                  </TableCell>
                  <TableCell component={'td'} align="right">
                    {numberToCurrency(seasonItem.amount)}
                  </TableCell>
                  <TableCell component={'td'}></TableCell>
                  <TableCell component={'td'}></TableCell>
                  <TableCell component={'td'}></TableCell>
                  <TableCell component={'td'}></TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
      </TableBody>
      {data?.mgReports && data?.mgReports.length > 0 && (
        <TableBody component={'tbody'} className={classes.tableBody}>
          <TableRow component={'tr'}>
            <TableCell component={'td'} className={classes.tableTitle} colSpan={2}></TableCell>
            <TableCell component={'td'} className={classes.tableTitle} align="left" colSpan={1234}>
              * Minimum Guarantee Contract Details
            </TableCell>
          </TableRow>
          <TableRow component={'tr'} className={`${classes.tableRow} ${classes.thead}`}>
            <TableCell component={'td'} rowSpan={2} style={{ width: 30 }}></TableCell>
            <TableCell component={'td'} rowSpan={2} style={{ width: 30 }}></TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              M.G. Contract Type
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2} style={{ width: 157 }}>
              Story Title
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Season Title
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Season ID
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Writer&apos;s name
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Total Coins(Redeem ad + Carried on)
            </TableCell>
            <TableCell component={'td'} align="center" colSpan={3}>
              Earnings($)
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Advance Payment($)
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Total Earnings Recouped($)
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Earnings Receivable($)
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Remaining Advance($)
            </TableCell>
            <TableCell component={'td'} align="center" rowSpan={2}>
              Payable($)
            </TableCell>
          </TableRow>
          <TableRow component={'tr'} className={`${classes.tableRow} ${classes.thead}`}>
            <TableCell component={'td'} align="center">
              Paid Coins(Exclude Ads)
            </TableCell>
            <TableCell component={'td'} align="center">
              Ad Coins
            </TableCell>
            <TableCell component={'td'} align="center">
              Amount
            </TableCell>
          </TableRow>
          {isLoading && <TableSkeleton rows={1} columns={6} />}
          {!isLoading &&
            data &&
            data.mgReports?.map(item => {
              const { contractType, storyTitle, seasonTitle, writerName, writerId, storyId, seasonId } = getMGContractType(item);
              return (
                <React.Fragment key={`transfer-detail-row-story-${item.contract.id}`}>
                  <TableRow component={'tr'} className={classes.tableRow}>
                    <TableCell component={'td'}></TableCell>
                    <TableCell component={'td'}></TableCell>
                    <TableCell component={'td'} align="left">
                      {contractType}
                    </TableCell>
                    <TableCell component={'td'} align="left">
                      {storyId ? (
                        <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${storyId}`} target="_blank">
                          {storyTitle}
                        </Link>
                      ) : (
                        storyTitle
                      )}
                    </TableCell>
                    <TableCell component={'td'} align="left">
                      {seasonTitle}
                    </TableCell>
                    <TableCell component={'td'} align="center">
                      {storyId && seasonId ? (
                        <Link href={`${process.env.CREW_DEFAULT_URI}/stories/${storyId}/seasons/${seasonId}`} target="_blank">
                          {seasonId}
                        </Link>
                      ) : (
                        seasonId ?? '-'
                      )}
                    </TableCell>
                    <TableCell component={'td'} align="center">
                      <RouterLink className={classes.routerLink} to={`/penname/v/${writerId}`}>
                        {writerName}
                      </RouterLink>
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {Number(item.paidCoins).toLocaleString()}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.paidEarnings - item.adsEarnings)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.adsEarnings)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.paidEarnings)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.contract.minimumGuarantee?.advancePayment)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.cumulativeEarnings - item.paidEarnings)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.receivableEarnings)}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(Math.max((item.contract.minimumGuarantee?.advancePayment ?? 0) - item.cumulativeEarnings, 0))}
                    </TableCell>
                    <TableCell component={'td'} align="right">
                      {numberToCurrency(item.paidEarnings - item.receivableEarnings)}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
        </TableBody>
      )}
    </>
  );
};

export default memo(TransferQuarterlyStories);
